import { SharedState } from 'app/types-shared';

export const getImportSetAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.interfaceAdministration?.administrationCentral;
